/* ============================================================
   GLOWGIRL LANDING (Oct 2026)
   Line-up pack pills + quick add, quiz, day timeline, gummy tabs,
   routine builder and the scroll-filled statement.
   Every module checks for its own markup first, so this file is
   safe to load on every page.
   ============================================================ */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function eur(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---- bundles (Theme settings > Bundles, rendered by gg-bundle-data) ---- */
  var bundles = [];
  try {
    var bEl = document.getElementById('gg-bundles');
    if (bEl) bundles = JSON.parse(bEl.textContent) || [];
  } catch (e) { bundles = []; }
  bundles = bundles.filter(function (b) { return b && b.available && b.members && b.members.length > 1; });
  function memberIds(b) { return b.members.map(function (m) { return m.id; }); }
  function memberSum(b) { return b.members.reduce(function (a, m) { return a + (m.price || 0); }, 0); }
  /* the bundle that is exactly these 1-bottle variants, if any */
  function exactBundle(ids) {
    if (!ids.length) return null;
    for (var i = 0; i < bundles.length; i++) {
      var m = memberIds(bundles[i]);
      if (m.length === ids.length && ids.every(function (id) { return m.indexOf(id) > -1; })) return bundles[i];
    }
    return null;
  }
  /* a bundle that is these variants plus exactly one more */
  function nearBundle(ids) {
    if (!ids.length) return null;
    for (var i = 0; i < bundles.length; i++) {
      var m = memberIds(bundles[i]);
      if (m.length === ids.length + 1 && ids.every(function (id) { return m.indexOf(id) > -1; })) return bundles[i];
    }
    return null;
  }
  window.GlowBundles = { list: bundles, exact: exactBundle, near: nearBundle, sum: memberSum };

  /* ---- shared add-to-bag ---- */
  function addItems(items, btn) {
    if (!items.length) return Promise.resolve();
    var label = btn ? btn.querySelector('[data-gg-add-text]') : null;
    var before = label ? label.textContent : '';
    if (btn) { btn.disabled = true; if (label) label.textContent = 'Adding…'; }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return r.json();
    }).then(function () {
      if (btn) { btn.classList.add('is-added'); if (label) label.textContent = 'Added ✓'; }
      if (window.GlowCart && window.GlowCart.refresh) window.GlowCart.refresh(true);
      else window.location.href = root + 'cart';
    }).catch(function () {
      if (label) label.textContent = 'Try again';
    }).then(function () {
      if (!btn) return;
      setTimeout(function () {
        btn.disabled = false; btn.classList.remove('is-added');
        if (label) label.textContent = before;
      }, 2200);
    });
  }

  /* ---- generic single add buttons (line-up, day timeline) ---- */
  $all('[data-gg-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = parseInt(btn.getAttribute('data-id'), 10);
      if (id) addItems([{ id: id, quantity: 1 }], btn);
    });
  });

  /* ---- line-up pack pills ---- */
  $all('[data-gg-card]').forEach(function (card) {
    var pills = $all('[data-gg-pack]', card);
    var price = card.querySelector('[data-gg-price]');
    var perday = card.querySelector('[data-gg-perday]');
    var add = card.querySelector('[data-gg-add]');
    var wasEl = card.querySelector('[data-gg-was]');
    var saveEl = card.querySelector('[data-gg-save]');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.setAttribute('aria-checked', p === pill ? 'true' : 'false'); });
        var cents = parseInt(pill.getAttribute('data-price'), 10);
        var count = parseInt(pill.getAttribute('data-count'), 10) || 1;
        var was = parseInt(pill.getAttribute('data-was'), 10) || 0;
        var save = was - cents;
        if (price) price.textContent = eur(cents);
        if (wasEl) { wasEl.hidden = save <= 0; if (save > 0) wasEl.textContent = eur(was); }
        if (saveEl) { saveEl.hidden = save <= 0; if (save > 0) saveEl.textContent = 'You save ' + eur(save); }
        if (perday) perday.textContent = eur(Math.round(cents / count / 30)) + '/day';
        if (add) add.setAttribute('data-id', pill.getAttribute('data-id'));
      });
    });
  });

  /* ---- statement: words fill in as the section scrolls past ---- */
  $all('[data-gg-fill]').forEach(function (el) {
    var words = $all('.gg-fillword', el);
    if (!words.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { words.forEach(function (w) { w.classList.add('is-on'); }); return; }
    var ticking = false;
    function paint() {
      ticking = false;
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      var start = vh * 0.85, end = vh * 0.35;
      var t = (start - r.top) / (start - end + r.height * 0.5);
      t = Math.max(0, Math.min(1, t));
      var on = Math.round(t * words.length);
      words.forEach(function (w, i) { w.classList.toggle('is-on', i < on); });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  });

  /* ---- generic tab helper (keyboard friendly) ---- */
  function tabs(tabsEls, panels, onChange) {
    function select(i, focus) {
      tabsEls.forEach(function (t, j) {
        var on = j === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (p, j) {
        var on = j === i;
        p.hidden = !on;
        p.classList.toggle('is-active', on);
      });
      if (onChange) onChange(i);
    }
    tabsEls.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabsEls.length) % tabsEls.length;
          select(n, true);
        }
      });
    });
    return select;
  }

  /* ---- day timeline ---- */
  $all('[data-gg-day]').forEach(function (sec) {
    var stops = $all('[data-gg-stop]', sec);
    var panels = $all('[data-gg-panel]', sec);
    var sun = sec.querySelector('[data-gg-sun]');
    function move(i) {
      var tone = stops[i] ? stops[i].getAttribute('data-tone') : 'morning';
      sec.setAttribute('data-tone', tone || 'morning');
      if (sun && stops.length) {
        var pct = stops.length === 1 ? 50 : (i / (stops.length - 1)) * 100;
        sun.style.left = pct + '%';
      }
    }
    tabs(stops, panels, move);
    move(0);
  });

  /* ---- inside the gummy ---- */
  $all('[data-gg-inside]').forEach(function (sec) {
    tabs($all('[data-gg-itab]', sec), $all('[data-gg-ipanel]', sec));
  });

  /* ---- routine builder ---- */
  $all('[data-gg-builder]').forEach(function (sec) {
    var picks = $all('[data-gg-pick]', sec);
    var count = sec.querySelector('[data-gg-count]');
    var sum = sec.querySelector('[data-gg-sum]');
    var ship = sec.querySelector('[data-gg-ship]');
    var btn = sec.querySelector('[data-gg-build-add]');
    var btnText = btn ? btn.querySelector('[data-gg-add-text]') : null;
    var btnLabel = btnText ? btnText.textContent : '';
    var wasEl = sec.querySelector('[data-gg-was]');
    var dealEl = sec.querySelector('[data-gg-deal]');
    var dealText = sec.querySelector('[data-gg-deal-text]');
    var hint = sec.querySelector('[data-gg-hint]');
    var threshold = ship ? parseInt(ship.getAttribute('data-threshold'), 10) || 0 : 0;
    var deal = null;
    function nameOf(id) {
      var p = picks.filter(function (x) { return parseInt(x.getAttribute('data-id'), 10) === id; })[0];
      return p ? p.getAttribute('data-name') : '';
    }
    function update() {
      var chosen = picks.filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; });
      var ids = chosen.map(function (p) { return parseInt(p.getAttribute('data-id'), 10); });
      var total = chosen.reduce(function (a, p) { return a + (parseInt(p.getAttribute('data-price'), 10) || 0); }, 0);
      deal = exactBundle(ids);
      var pay = deal ? deal.price : total;
      if (count) count.textContent = chosen.length + (chosen.length === 1 ? ' bottle' : ' bottles');
      if (sum) sum.textContent = eur(pay);
      if (wasEl) { wasEl.hidden = !deal; wasEl.textContent = deal ? eur(total) : ''; }
      if (dealEl) {
        dealEl.hidden = !deal;
        if (deal && dealText) dealText.textContent = deal.name + ' bundle \u00b7 you save ' + eur(total - deal.price);
      }
      if (hint) {
        var near = deal ? null : nearBundle(ids);
        hint.hidden = !near;
        if (near) {
          var missing = near.members.filter(function (m) { return ids.indexOf(m.id) < 0; })[0];
          var nm = nameOf(missing.id) || missing.name;
          hint.textContent = 'Add ' + nm + ' to unlock the ' + near.name + ' bundle and save ' + eur(memberSum(near) - near.price) + '.';
        }
      }
      if (btnText) btnText.textContent = deal ? 'Add the ' + deal.name + ' bundle' : btnLabel;
      if (ship) {
        if (!chosen.length) ship.textContent = '';
        else if (threshold && pay < threshold) ship.textContent = (ship.getAttribute('data-below') || '').replace('[amount]', eur(threshold - pay));
        else ship.textContent = ship.getAttribute('data-free') || '';
      }
      if (btn) btn.disabled = !chosen.length;
    }
    picks.forEach(function (p) {
      p.addEventListener('click', function () {
        p.setAttribute('aria-pressed', p.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        update();
      });
    });
    if (btn) btn.addEventListener('click', function () {
      var items = deal ? [{ id: deal.id, quantity: 1 }] :
        picks.filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; })
          .map(function (p) { return { id: parseInt(p.getAttribute('data-id'), 10), quantity: 1 }; });
      addItems(items, btn);
    });
    update();
  });

  /* ---- quiz ---- */
  $all('[data-gg-quiz]').forEach(function (sec) {
    var data = {};
    try { data = JSON.parse(sec.querySelector('[data-gg-products]').textContent); } catch (e) { return; }
    var steps = $all('[data-gg-step]', sec);
    var dots = $all('[data-gg-dot]', sec);
    var result = sec.querySelector('[data-gg-result]');
    var totalEl = sec.querySelector('[data-gg-total]');
    var addBtn = sec.querySelector('[data-gg-quiz-add]');
    var picks = [];
    var q1 = null;
    var qdeal = null;

    function show(n) {
      steps.forEach(function (s) {
        var on = s.getAttribute('data-gg-step') === String(n);
        s.hidden = !on;
        s.classList.toggle('is-active', on);
      });
      dots.forEach(function (d) { d.classList.toggle('is-on', parseInt(d.getAttribute('data-gg-dot'), 10) <= n); });
    }

    function row(img, tag, name, url, linkText, price, was, dealLine) {
      var r = document.createElement('div');
      r.className = 'gg-qres' + (was ? ' gg-qres--bundle' : '');
      r.innerHTML =
        (img ? '<img src="' + img + '" alt="" width="68" height="68" loading="lazy">' : '') +
        '<span class="gg-qres__main"><span class="gg-qres__tag"></span><span class="gg-qres__name"></span>' +
        (dealLine ? '<span class="gg-qres__deal"></span>' : '') + '<a></a></span>' +
        '<span class="gg-qres__price">' + (was ? '<s></s>' : '') + '<span></span></span>';
      r.querySelector('.gg-qres__tag').textContent = tag || '';
      r.querySelector('.gg-qres__name').textContent = name || '';
      if (dealLine) r.querySelector('.gg-qres__deal').textContent = dealLine;
      var a = r.querySelector('a'); a.href = url; a.textContent = linkText;
      if (was) r.querySelector('.gg-qres__price s').textContent = eur(was);
      r.querySelector('.gg-qres__price span').textContent = eur(price);
      result.appendChild(r);
    }

    function render() {
      result.innerHTML = '';
      var total = 0;
      var ids = picks.map(function (k) { return data[k] && data[k].variants && data[k].variants[0] ? data[k].variants[0].id : 0; });
      qdeal = exactBundle(ids);
      if (qdeal) {
        var sep = picks.reduce(function (a, k) { return a + data[k].variants[0].price; }, 0);
        var img = qdeal.image || (data[picks[0]] && data[picks[0]].image);
        var names = picks.map(function (k) { return data[k].name; }).join(' + ');
        row(img, 'Bundle \u00b7 ' + names, qdeal.name + ' bundle', qdeal.url, 'See what\u2019s inside', qdeal.price, sep,
            'You save ' + eur(sep - qdeal.price));
        total = qdeal.price;
      }
      if (!qdeal) picks.forEach(function (key) {
        var p = data[key];
        if (!p || !p.variants || !p.variants.length) return;
        var v = p.variants[0];
        total += v.price;
        row(p.image, p.tag, p.name, p.url, 'See details', v.price, 0, '');
      });
      var ship = !data.freeShip ? '' : (total >= data.freeShip ? 'Free shipping included' : 'Add ' + eur(data.freeShip - total) + ' more for free shipping');
      totalEl.innerHTML = '<span>Total<small></small></span><span></span>';
      totalEl.querySelector('small').textContent = ship;
      totalEl.lastChild.textContent = eur(total);
    }

    $all('[data-gg-q1]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        q1 = b.getAttribute('data-gg-q1');
        if (q1 === 'skin') { picks = ['skin']; render(); show(3); return; }
        show(2);
      });
    });
    $all('[data-gg-q2]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        picks = q1 === 'both' ? ['am', 'pm'] : [q1];
        if (b.getAttribute('data-gg-q2') === 'yes') picks.push('skin');
        picks = picks.filter(function (k) { return data[k]; });
        render(); show(3);
      });
    });
    var back = sec.querySelector('[data-gg-back]');
    if (back) back.addEventListener('click', function () { show(1); });
    var restart = sec.querySelector('[data-gg-restart]');
    if (restart) restart.addEventListener('click', function () { picks = []; q1 = null; show(1); });
    if (addBtn) addBtn.addEventListener('click', function () {
      if (qdeal) { addItems([{ id: qdeal.id, quantity: 1 }], addBtn); return; }
      var items = picks.map(function (k) { return data[k] && data[k].variants[0] ? { id: data[k].variants[0].id, quantity: 1 } : null; })
        .filter(Boolean);
      addItems(items, addBtn);
    });
  });
})();

/* ---- Shop all: Gummies / Bundles filter ---- */
(function () {
  'use strict';
  var root = document.querySelector('[data-gg-coll]');
  if (!root) return;
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-gg-filter]'));
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kind]'));
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      var f = c.getAttribute('data-gg-filter');
      chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
      cards.forEach(function (card) { card.hidden = f !== 'all' && card.getAttribute('data-kind') !== f; });
    });
  });
})();
